import Box from '@material-ui/core/Box';
import ButtonBase from '@material-ui/core/ButtonBase';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

const propsToIgnore = {
  classes: true,
  className: true,
  color: true,
  component: true,
  disabled: true,
  shape: true,
  size: true,
  variant: true,
};

const TablePaginationItem = forwardRef((props, ref) => {
  const { selected, page, type, goToPageEvent, ...other } = props;
  const onClick = () => {};

  const buttonProps = Object.entries(other).reduce((acc, [key, value]) => {
    if (propsToIgnore[key]) return acc;
    acc[key] = value;
    return acc;
  }, {});

  return (
    <ButtonBase ref={ref} {...buttonProps} onClick={onClick}>
      <Box
        px={2}
        py={1}
        border={2}
        borderTop={0}
        borderLeft={0}
        borderRight={0}
        borderColor={selected ? 'secondary.main' : 'transparent'}
      >
        {type === 'page' && page}
      </Box>
    </ButtonBase>
  );
});

TablePaginationItem.defaultProps = {
  page: undefined,
  goToPageEvent: undefined,
  selected: false,
  type: 'page',
};

TablePaginationItem.propTypes = {
  page: PropTypes.number,
  goToPageEvent: PropTypes.string,
  selected: PropTypes.bool,
  type: PropTypes.oneOf([
    'page',
    'first',
    'last',
    'next',
    'previous',
    'start-ellipsis',
    'end-ellipsis',
  ]),
};

export default TablePaginationItem;
